import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { PreferenceService } from '@shared/services/cabinet/preference.service';

const GRAND_LIVRE_HELP_MAPPING_WCL: Record<string, string> = {
  generale: 'WCL.020.070',
  client: 'WCL.020.080',
  fournisseur: 'WCL.020.090',
};

const GRAND_LIVRE_HELP_MAPPING_EXC: Record<string, string> = {
  generale: 'W.020.070',
  client: 'W.020.080',
  fournisseur: 'W.020.090',
};

export const grandLivreHelpCodeResolver: ResolveFn<string | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const type = route.paramMap.get('type');
  if (!type) {
    return null;
  }
  if (inject(PreferenceService).isCollab) {
    return GRAND_LIVRE_HELP_MAPPING_EXC[type] || null;
  } else {
    return GRAND_LIVRE_HELP_MAPPING_WCL[type] || null;
  }
};
